export default "__VITE_ASSET__BHCftteO__"